import React from "react";
import { Link } from "react-router-dom";
import { CATEGORY_ORDER, CATEGORY_LABELS } from "../lib/api";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#020202] border-t border-white/5 mt-32">
      <div className="container-ml py-20 md:py-24">
        {/* Columns */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 py-8">
          <div className="md:col-span-5">
            <p className="wordmark text-3xl tracking-[0.16em] mb-6 text-[var(--ml-text)]">
              Menorca<span className="text-[var(--ml-gold)]">·Luxury</span>
            </p>
            <p className="text-[var(--ml-text-dim)] text-sm leading-relaxed max-w-md">
              A luxury travel guide to the most discreet hospitality on the Mediterranean's quietest island. MenorcaLuxury.com
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="overline mb-5">Browse</p>
            <ul className="space-y-3">
              {CATEGORY_ORDER.map(c => (
                <li key={c}>
                  <Link to={`/category/${c}`} className="text-sm tracking-[0.08em] text-[var(--ml-text-dim)] hover:text-[var(--ml-gold)] transition-colors" data-testid={`footer-cat-${c}`}>
                    {CATEGORY_LABELS[c]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="overline mb-5">About</p>
            <ul className="space-y-3">
              <li><Link to="/concierge" className="text-sm tracking-[0.08em] text-[var(--ml-text-dim)] hover:text-[var(--ml-gold)] transition-colors" data-testid="footer-concierge">Concierge</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="overline mb-5">Contact</p>
            <ul className="space-y-3 text-sm tracking-[0.08em] text-[var(--ml-text-dim)]">
              <li>hola@menorcaluxury.com</li>
            </ul>
          </div>
        </div>

        {/* Marquee mast */}
        <div className="border-t border-white/5 overflow-hidden">
          <div className="flex whitespace-nowrap marquee-track py-6 select-none">
            {Array.from({ length: 6 }).map((_, i) => (
              <span key={i} className="font-serif-ml italic text-7xl md:text-9xl px-6 text-[var(--ml-text)]/30">
                Menorca · Luxury · Hotels · Villas ·
              </span>
            ))}
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 pt-8 text-[0.65rem] tracking-[0.22em] uppercase text-[var(--ml-text-muted)]">
          <p>© 2026 Menorca Luxury · All rights reserved</p>
          <p>A luxury travel guide · Made in Menorca</p>
        </div>
      </div>
    </footer>
  );
}
